const KEY = 'forum.player.textureLive.v1'
export const TEXTURE_LIVE_TTL_MS = 90 * 24 * 60 * 60 * 1000
// A negative result may be a transient browser/driver regression rather than
// a stable device property, so it decays quickly instead of pinning the
// player to flat for months.
export const TEXTURE_DEAD_TTL_MS = 24 * 60 * 60 * 1000

interface Entry {
  value: boolean
  fp: string
  ts: number
}

export function fingerprint(userAgent: string): string {
  return userAgent
}

export function getCachedTextureLive(
  now: number,
  userAgent: string,
  store: Storage,
): boolean | undefined {
  try {
    const raw = store.getItem(KEY)
    if (!raw) return undefined
    const entry = JSON.parse(raw) as Entry
    if (entry.fp !== fingerprint(userAgent)) return undefined
    const ttl = entry.value ? TEXTURE_LIVE_TTL_MS : TEXTURE_DEAD_TTL_MS
    if (now - entry.ts > ttl) return undefined
    return entry.value
  } catch {
    return undefined
  }
}

export function clearCachedTextureLive(store: Storage): void {
  try {
    store.removeItem(KEY)
  } catch {
    // Storage may be unavailable (private mode / partitioned iframe) — ignore.
  }
}

export function setCachedTextureLive(
  value: boolean,
  now: number,
  userAgent: string,
  store: Storage,
): void {
  try {
    const entry: Entry = { value, fp: fingerprint(userAgent), ts: now }
    store.setItem(KEY, JSON.stringify(entry))
  } catch {
    // Storage may be unavailable (private mode / partitioned iframe) — ignore.
  }
}
